import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, concatMap, shareReplay, tap, finalize } from 'rxjs/operators';
import { Filters } from 'src/app/models/filters.model';
import { EventsService } from 'src/app/services/events.service';
import { SearcherService } from 'src/app/services/searcher.service';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'page-full-screen-contacts-component',
  templateUrl: 'full-screen-contacts-component.html',
  styleUrls: ['full-screen-contacts-component.scss']
})
export class FullScreenContactsComponentPage {
  public initConfig;
  public endpoint;
  public itemType: string = 'contacts';
  public filters$: BehaviorSubject<Filters> = new BehaviorSubject({
    searchKey: '',
    start: 0,
    length: 20
  });

  private pageId: number;
  /** Route flag `agenda` when listing from an agenda component */
  private routeAgenda: string | null;
  public page$: Observable<any>;
  /** Keeps toolbar + item-searcher mounted on back navigation until page$ emits again */
  public latestPage: any = null;
  private $event;

  public id: number;
  public filters: { searchKey: string; start: number; orderBy: string; orderDir: string; length: number };
  title: string;
  public forbidden: boolean = false;
  public listLoading = true;
  public readonly listSkeletonPlaceholders = [1, 2, 3];

  constructor(
    public navCtrl: NavController,
    public router: Router,
    private searcherService: SearcherService,
    private route: ActivatedRoute,
    public events: EventsService
  ) {}

  ionViewWillEnter() {
    this.listLoading = true;

    const nextPageId = +this.route.snapshot.paramMap.get('id');
    const agendaParam = this.route.snapshot.paramMap.get('agenda');
    if (
      this.pageId !== undefined &&
      (nextPageId !== this.pageId || this.routeAgenda !== agendaParam)
    ) {
      this.latestPage = null;
    }
    this.pageId = nextPageId;
    this.routeAgenda = agendaParam;

    const elementsUrl = this.routeAgenda
      ? `${Environment.API_BASE_URL_V2}/api/empatica/v1/components/agenda/${this.pageId}/elements`
      : `${Environment.API_BASE_URL_V2}/api/empatica/v1/components/contacts/${this.pageId}/elements`;

    this.page$ = this.buildPage$(elementsUrl);
    this.getAllItems({ filters: { ...this.filters$.value, start: 0 } });
  }

  private buildPage$(elementsUrl: string): Observable<any> {
    return this.filters$.pipe(
      concatMap((filters) =>
        this.searcherService
          .allItems(elementsUrl, filters, this.itemType)
          .pipe(finalize(() => (this.listLoading = false)))
      ),
      tap(() => this.$event && this.$event.target.complete && this.$event.target.complete()),
      tap((response) => {
        this.latestPage = response;
      }),
      tap((response) => this.events.pages$$.next(response.title)),
      tap(() => (this.forbidden = false)),
      catchError((err: any) => {
        if (err.status === 403) {
          this.forbidden = true;
        }

        throw err;
      }),
      shareReplay()
    );
  }

  public goToDetail(contact) {
    const agenda = Boolean(contact.item.username) ? '/agenda' : '';
    this.router.navigate([`contacts/detail/${contact.item.id}${agenda}`]);
  }

  public getAllItems({ filters, event = null }) {
    if (event) this.$event = event;
    this.filters$.next(filters);
  }
}
